module.exports = __webpack_public_path__ + "img/PACI Scan AR - 2.786ec07f.png";